/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     伙伴数据管理
  +--------------------------------------------------------------------------------------
*/

const prmStore = {
  state: {
    intentionLevelArr: [
      { value: 3, title: "高" },
      { value: 2, title: "普通" },
      { value: 1, title: "低" },
    ],
  },

  mutations: {
  },

  actions: {
  }
}

export default prmStore
